// @flow
import getServiceWorkerCacheData from 'app/packages/trace-logger/getServiceWorkerCacheData';
import Stopwatch from 'app/packages/trace-logger/Stopwatch';

const stringifyMaybeNumber = (value: ?number) =>
  typeof value === 'number' ? value.toString() : '';

export default function addResourceAnnotations(subStopwatch: Stopwatch, timingObject: Object) {
  if (!timingObject) {
    return;
  }
  const timingKeys = [
    'connectEnd',
    'connectStart',
    'domainLookupEnd',
    'domainLookupStart',
    'fetchStart',
    'requestStart',
    'redirectEnd',
    'redirectStart',
    'responseEnd',
    'responseStart',
    'secureConnectionStart',
    'startTime',
    'workerStart',
  ];

  timingKeys.forEach((key) => {
    subStopwatch.addAnnotation(key, timingObject[key] + window.performance.timing.navigationStart);
  });
  // Also add some binary annotations so we can tell which resource this is and how large
  subStopwatch.addBinaryAnnotation({
    name: ['link', 'script'].includes(timingObject.initiatorType) ? 'name' : 'url',
    value: timingObject.name,
    annotation_type: 'STRING',
  });
  subStopwatch.addBinaryAnnotation({
    name: 'transferSize',
    value: stringifyMaybeNumber(timingObject.transferSize),
    annotation_type: 'STRING',
  });
  subStopwatch.addBinaryAnnotation({
    name: 'decodedBodySize',
    value: stringifyMaybeNumber(timingObject.decodedBodySize),
    annotation_type: 'STRING',
  });
  if (['link', 'script'].includes(timingObject.initiatorType)) {
    getServiceWorkerCacheData().then((cacheData) => {
      let value = false;
      // If no data comes back, assume SW isn't supported or is currently installing so no files came from cache
      if (cacheData) {
        const name = timingObject.name.substr(timingObject.name.lastIndexOf('/') + 1);
        value = !!cacheData.hits.find((hit) => hit.name === name);
      }
      subStopwatch.addBinaryAnnotation({
        name: 'fromCache',
        value,
        annotation_type: 'BOOL',
      });
    });
  } else {
    subStopwatch.addBinaryAnnotation({
      name: 'fromCache',
      value: timingObject.transferSize === 0,
      annotation_type: 'BOOL',
    });
  }
  if (timingObject.initiatorType === 'script') {
    const scriptEl = document.querySelector(`head > script[src='${timingObject.name}']`);
    if (scriptEl) {
      subStopwatch.addBinaryAnnotation({
        name: 'defer',
        value: scriptEl.hasAttribute('defer'),
        annotation_type: 'BOOL',
      });
    }
  }
}
